<template>
  <div class="object-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="objectTypeLabel"><strong>Tipo:</strong> {{ objectTypeLabel }}</span>
      <span v-if="data.description"><strong>Descrição:</strong> {{ data.description }}</span>
      <span v-if="brandModel"><strong>Marca/Modelo:</strong> {{ brandModel }}</span>
      <span v-if="data.quantity"><strong>Qtd:</strong> {{ data.quantity }}</span>
      <span v-if="data.serial_number"><strong>Série:</strong> {{ data.serial_number }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObjectSummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    brandModel() {
      return [this.data.brand, this.data.model].filter(Boolean).join(' ')
    },
    objectTypeLabel() {
      const map = {
        arma: 'Arma',
        eletronico: 'Eletrônico',
        documento: 'Documento',
        joia: 'Joia/Valor',
        outro: 'Outro',
      }
      return map[this.data.object_type] || this.data.object_type || ''
    },
  },
}
</script>
